import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoWordmark = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	x: "0px",
	y: "0px",
	viewBox: "0 0 713.92 294.86",
	width: 120,
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M228.47,131.78v64.95h40.45v13.71h-55.28v-78.66H228.47z",
			fill: "#FFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M333.41,182.8c0,15.96-10.9,28.88-28.88,28.88c-17.98,0-28.77-12.92-28.77-28.88c0-15.84,11.01-28.88,28.65-28.88 C322.06,153.92,333.41,166.95,333.41,182.8z M289.48,182.8c0,8.43,5.06,16.29,15.06,16.29c10,0,15.06-7.87,15.06-16.29 c0-8.32-5.84-16.41-15.06-16.41C294.64,166.39,289.48,174.48,289.48,182.8z",
			fill: "#FFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M397.9,182.8c0,15.96-10.9,28.88-28.88,28.88s-28.77-12.92-28.77-28.88c0-15.84,11.01-28.88,28.65-28.88 C386.56,153.92,397.9,166.95,397.9,182.8z M353.97,182.8c0,8.43,5.06,16.29,15.06,16.29c10,0,15.06-7.87,15.06-16.29 c0-8.32-5.84-16.41-15.06-16.41C359.14,166.39,353.97,174.48,353.97,182.8z",
			fill: "#FFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M444.19,210.44v-29.66c0-7.3-3.82-13.93-11.35-13.93c-7.42,0-11.8,6.63-11.8,13.93v29.66h-13.71v-55.51h12.7l1.01,6.74 c2.92-5.62,9.33-7.64,14.61-7.64c6.63,0,13.26,2.7,16.4,10.34c4.94-7.87,11.35-10.11,18.54-10.11c15.73,0,23.48,9.66,23.48,26.29 v29.89h-13.71v-29.89c0-7.3-3.03-13.48-10.45-13.48c-7.42,0-12.02,6.4-12.02,13.71v29.66H444.19z",
			fill: "#FFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M521.61,131.9v78.54h-13.6V131.9H521.61z",
			fill: "#FFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M548.57,139.42c0,10.68-16.18,10.68-16.18,0C532.39,128.75,548.57,128.75,548.57,139.42z M533.63,154.82v55.62h13.71 v-55.62H533.63z",
			fill: "#FFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M579.02,139.42v15.73h15.28v11.8h-15.39v23.93c0,5.28,2.92,7.87,7.19,7.87c2.14,0,4.61-0.67,6.63-1.69l3.82,11.69 c-3.93,1.57-7.19,2.25-11.35,2.36c-12.02,0.45-19.89-6.4-19.89-20.23v-23.93h-10.34v-11.8h10.34v-14.27L579.02,139.42z",
			fill: "#FFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M616.21,187.63c0.9,6.85,6.86,11.8,16.52,11.8c5.06,0,11.69-1.91,14.83-5.17l8.76,8.65c-5.84,6.07-15.39,8.99-23.82,8.99 c-19.1,0-30.45-11.8-30.45-29.55c0-16.85,11.46-28.99,29.44-28.99c18.54,0,30.11,11.46,27.98,34.27H616.21z M646.32,176.28 c-0.9-7.19-6.52-10.79-14.38-10.79c-7.42,0-13.48,3.59-15.51,10.79H646.32z",
			fill: "#FFF"
		})
	] }) }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "SvgLogoID_1_",
				gradientUnits: "userSpaceOnUse",
				x1: 125.6397,
				y1: 31.5784,
				x2: 125.6397,
				y2: 284.6969,
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: 0,
						stopColor: "#FFBB00"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .2752,
						stopColor: "#FF793E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6071,
						stopColor: "#DC288E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6511,
						stopColor: "#CC2394"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8131,
						stopColor: "#9614A8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .9343,
						stopColor: "#740AB5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#6706BA"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#SvgLogoID_1_)",
				d: "M119.53,88.64c-8.57-16.59,5.92-18.39,9.67-31.75c3.28,7.53-11.26,19.44-2.25,29.04 c8.48-2.03,2.35-9.42,12.08-15.23c-5.18,6.38-0.38,9.83-6.22,19.02c34.74-23.39-7.43-55.53-7.43-55.53 c3.41,7.73-3.21,15.91-9.44,20.48c-7.78,5.71-2.51,13.56-2.51,13.56c-7.4-3.89-3.75-13-3.75-13 C105.81,60.36,97.08,82.4,119.53,88.64z"
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "SvgLogoID_2_",
				gradientUnits: "userSpaceOnUse",
				x1: 125.6399,
				y1: 31.5784,
				x2: 125.6399,
				y2: 284.6969,
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: 0,
						stopColor: "#FFBB00"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .2752,
						stopColor: "#FF793E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6071,
						stopColor: "#DC288E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6511,
						stopColor: "#CC2394"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8131,
						stopColor: "#9614A8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .9343,
						stopColor: "#740AB5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#6706BA"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#SvgLogoID_2_)",
				d: "M107.81,103.09h35.65c2.64,0,4.78-2.14,4.78-4.78s-2.14-4.78-4.78-4.78h-35.65c-2.64,0-4.78,2.14-4.78,4.78 S105.18,103.09,107.81,103.09z"
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "SvgLogoID_3_",
				gradientUnits: "userSpaceOnUse",
				x1: 125.6826,
				y1: 31.5784,
				x2: 125.6826,
				y2: 284.6969,
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: 0,
						stopColor: "#FFBB00"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .2752,
						stopColor: "#FF793E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6071,
						stopColor: "#DC288E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6511,
						stopColor: "#CC2394"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8131,
						stopColor: "#9614A8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .9343,
						stopColor: "#740AB5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#6706BA"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#SvgLogoID_3_)",
				d: "M194.02,121.73c-3.99,0.47-7.73,1.06-11.28,1.74v0.03c-1.13,0.19-2.6,0.47-4.38,0.86 c-2.32,0.51-5.14,1.21-8.32,2.18c-1.74,0.52-3.61,1.13-5.55,1.82c-0.17,0.06-0.35,0.13-0.52,0.19c-2.48,0.9-5.1,1.94-7.81,3.15 c-1.82,0.8-3.67,1.68-5.55,2.65c-2.73,1.4-5.53,2.98-8.32,4.75c-1.43,0.9-2.87,1.86-4.3,2.87v-13.36c0-0.24,0.01-0.48,0.03-0.72 c0.01-0.17,0.02-0.32,0.04-0.48c0.03-0.39,0.1-0.78,0.18-1.15c0.17-0.86,0.44-1.66,0.79-2.43c0.03-0.09,0.07-0.17,0.11-0.26 l0.02-0.02c1.25-2.55,3.39-4.59,6.02-5.69c0.88-0.37,1.81-0.64,2.77-0.78c0.58-0.09,1.17-0.13,1.78-0.13 c0.13,0,0.28-0.01,0.41-0.02c0.16-0.02,0.31-0.04,0.45-0.06c0.44-0.07,0.88-0.21,1.28-0.4c0.1-0.05,0.21-0.1,0.32-0.16 c0.15-0.09,0.31-0.17,0.44-0.29c0.09-0.06,0.17-0.11,0.25-0.18c0.08-0.06,0.13-0.11,0.21-0.17c0.22-0.19,0.42-0.41,0.6-0.64 l0.02-0.02c0.26-0.35,0.48-0.74,0.64-1.15c0.04-0.1,0.08-0.21,0.12-0.33c0.02-0.09,0.06-0.18,0.06-0.29l0.03-0.13 c0.03-0.1,0.05-0.19,0.06-0.29c0.02-0.1,0.03-0.22,0.04-0.34c0.04-0.6-0.04-1.19-0.2-1.74c-0.1-0.29-0.22-0.57-0.37-0.85 c-0.22-0.4-0.49-0.78-0.82-1.09c-0.32-0.33-0.69-0.61-1.11-0.83c-0.67-0.36-1.44-0.58-2.27-0.58h-48.54 c-2.73,0-4.94,2.31-4.76,5.1c0.01,0.12,0.02,0.24,0.04,0.34c0.01,0.1,0.03,0.19,0.06,0.29l0.03,0.13c0.01,0.1,0.04,0.2,0.06,0.29 c0.03,0.11,0.08,0.23,0.12,0.33c0.06,0.13,0.1,0.26,0.17,0.39c0.06,0.13,0.14,0.27,0.22,0.4c0.07,0.11,0.15,0.23,0.25,0.34 l0.02,0.03c0.09,0.12,0.17,0.22,0.28,0.33c0.09,0.1,0.17,0.18,0.27,0.27l0.17,0.15c0.22,0.18,0.46,0.36,0.71,0.5 c0.51,0.29,1.07,0.51,1.66,0.6c0.14,0.02,0.3,0.04,0.45,0.06c0.13,0.01,0.27,0.02,0.4,0.02c0.4,0,0.81,0.02,1.2,0.06 c1.18,0.13,2.31,0.42,3.37,0.86c2.73,1.14,4.92,3.29,6.14,5.98c0.44,0.94,0.75,1.94,0.91,3c0.02,0.2,0.06,0.4,0.08,0.59 c0.01,0.16,0.02,0.31,0.03,0.48c0.02,0.24,0.03,0.48,0.03,0.72v13.37c-1.43-1.01-2.87-1.97-4.3-2.89 c-2.8-1.77-5.59-3.34-8.32-4.74c-1.88-0.97-3.73-1.85-5.55-2.65c-2.7-1.21-5.33-2.25-7.81-3.15c-0.17-0.06-0.35-0.13-0.52-0.19 c-1.94-0.69-3.8-1.3-5.55-1.82c-3.19-0.97-6-1.67-8.32-2.18c-2.06-0.45-3.71-0.75-4.89-0.95v-0.07 c-3.37-0.63-6.92-1.18-10.68-1.62l-3.15-0.37v100.44l2.72,0.1c10.06,0.35,19.14,2.62,27.14,5.88 c12.01,4.88,21.6,11.98,28.32,18.06c6.72,6.08,10.54,11.12,11.05,11.8l2.26,3.04l2.26-3.04c0.67-0.91,7.26-9.57,18.71-18.1 c5.72-4.27,12.65-8.51,20.66-11.76c8.01-3.25,17.08-5.52,27.14-5.88l2.72-0.1V121.35L194.02,121.73z M170.04,132.35 c3.14-1,5.96-1.75,8.32-2.3v7.89c-2.32,0.52-5.14,1.22-8.32,2.18V132.35z M170.04,145.93c3.14-1,5.96-1.74,8.32-2.3v7.9 c-2.32,0.51-5.14,1.21-8.32,2.18V145.93z M170.04,159.52c3.14-1.01,5.96-1.75,8.32-2.31v7.89c-2.32,0.51-5.14,1.21-8.32,2.18 V159.52z M170.04,173.1c3.14-1,5.96-1.75,8.32-2.31v7.9c-2.32,0.52-5.14,1.22-8.32,2.18V173.1z M170.04,186.68 c3.14-1,5.96-1.74,8.32-2.3v7.89c-2.32,0.52-5.14,1.22-8.32,2.18V186.68z M170.04,200.26c3.14-1.01,5.96-1.75,8.32-2.31v7.89 c-2.32,0.51-5.14,1.21-8.32,2.18V200.26z M156.16,137.81c2.88-1.36,5.68-2.53,8.33-3.53v7.67c-0.17,0.06-0.35,0.13-0.52,0.19 c-2.48,0.9-5.1,1.94-7.81,3.15V137.81z M156.16,151.39c2.88-1.36,5.68-2.54,8.33-3.54v7.67c-0.17,0.06-0.35,0.13-0.52,0.19 c-2.48,0.9-5.1,1.94-7.81,3.15V151.39z M156.16,164.97c2.88-1.36,5.68-2.53,8.33-3.53v7.67c-0.17,0.06-0.35,0.13-0.52,0.19 c-2.48,0.9-5.1,1.94-7.81,3.15V164.97z M156.16,178.55c2.88-1.36,5.68-2.53,8.33-3.53v7.67c-0.17,0.06-0.35,0.13-0.52,0.19 c-2.48,0.9-5.1,1.94-7.81,3.15V178.55z M156.16,192.14c2.88-1.36,5.68-2.54,8.33-3.54v7.67c-0.17,0.06-0.35,0.13-0.52,0.19 c-2.48,0.9-5.1,1.94-7.81,3.15V192.14z M156.16,205.72c2.88-1.36,5.68-2.53,8.33-3.53v7.67c-0.17,0.06-0.35,0.13-0.52,0.19 c-2.48,0.9-5.1,1.94-7.81,3.15V205.72z M142.29,145.75c2.77-1.9,5.56-3.6,8.32-5.11v7.3c-2.73,1.4-5.53,2.98-8.32,4.75V145.75z  M142.29,159.33c2.77-1.9,5.56-3.6,8.32-5.11v7.3c-2.73,1.4-5.53,2.98-8.32,4.75V159.33z M142.29,172.91 c2.77-1.9,5.56-3.59,8.32-5.1v7.29c-2.73,1.4-5.53,2.98-8.32,4.75V172.91z M142.29,186.49c2.77-1.9,5.56-3.6,8.32-5.11v7.3 c-2.73,1.4-5.53,2.98-8.32,4.75V186.49z M142.29,200.07c2.77-1.9,5.56-3.6,8.32-5.11v7.3c-2.73,1.4-5.53,2.98-8.32,4.75V200.07z  M142.29,213.65c2.77-1.9,5.56-3.59,8.32-5.1v7.29c-2.73,1.4-5.53,2.98-8.32,4.75V213.65z M100.67,140.64 c2.76,1.51,5.55,3.2,8.32,5.1v6.94c-2.8-1.77-5.59-3.34-8.32-4.74V140.64z M100.67,154.22c2.76,1.51,5.55,3.21,8.32,5.11v6.93 c-2.8-1.76-5.59-3.34-8.32-4.74V154.22z M100.67,167.8c2.76,1.51,5.55,3.21,8.32,5.1v6.94c-2.8-1.76-5.59-3.34-8.32-4.74V167.8z  M100.67,181.38c2.76,1.51,5.55,3.2,8.32,5.1v6.94c-2.8-1.77-5.59-3.34-8.32-4.74V181.38z M100.67,194.96 c2.76,1.51,5.55,3.21,8.32,5.11V207c-2.8-1.77-5.59-3.34-8.32-4.74V194.96z M100.67,208.54c2.76,1.51,5.55,3.21,8.32,5.1v6.94 c-2.8-1.76-5.59-3.34-8.32-4.74V208.54z M86.79,134.28c2.66,1,5.45,2.16,8.33,3.53v7.47c-2.7-1.2-5.33-2.25-7.81-3.15 c-0.17-0.06-0.35-0.13-0.52-0.19V134.28z M86.79,147.86c2.66,1,5.45,2.17,8.33,3.53v7.48c-2.7-1.21-5.33-2.25-7.81-3.15 c-0.17-0.06-0.35-0.13-0.52-0.19V147.86z M86.79,161.44c2.66,1,5.45,2.16,8.33,3.53v7.48c-2.7-1.2-5.33-2.25-7.81-3.15 c-0.17-0.06-0.35-0.13-0.52-0.19V161.44z M86.79,175.02c2.66,1,5.45,2.17,8.33,3.53v7.48c-2.7-1.2-5.33-2.25-7.81-3.15 c-0.17-0.06-0.35-0.13-0.52-0.19V175.02z M86.79,188.6c2.66,1,5.45,2.17,8.33,3.53v7.48c-2.7-1.21-5.33-2.25-7.81-3.15 c-0.17-0.06-0.35-0.13-0.52-0.19V188.6z M86.79,202.18c2.66,1,5.45,2.16,8.33,3.53v7.48c-2.7-1.2-5.33-2.25-7.81-3.15 c-0.17-0.06-0.35-0.13-0.52-0.19V202.18z M72.91,130.05c2.36,0.55,5.18,1.3,8.32,2.31v7.77c-3.19-0.96-6-1.66-8.32-2.18V130.05z  M72.91,143.63c2.36,0.55,5.18,1.3,8.32,2.3v7.78c-3.19-0.97-6-1.67-8.32-2.18V143.63z M72.91,157.21 c2.36,0.55,5.18,1.3,8.32,2.3v7.78c-3.19-0.97-6-1.67-8.32-2.18V157.21z M72.91,170.79c2.36,0.55,5.18,1.3,8.32,2.3v7.78 c-3.19-0.96-6-1.66-8.32-2.18V170.79z M72.91,184.38c2.36,0.55,5.18,1.3,8.32,2.3v7.77c-3.19-0.96-6-1.66-8.32-2.18V184.38z  M72.91,197.96c2.36,0.55,5.18,1.3,8.32,2.3v7.78c-3.19-0.97-6-1.67-8.32-2.18V197.96z M191.54,216.41 c-9.71,0.66-18.54,2.97-26.35,6.14c-12.8,5.21-22.9,12.71-29.98,19.11c-4.35,3.94-7.55,7.46-9.53,9.8 c-3.05-3.61-9.01-10.03-17.6-16.44c-6.04-4.5-13.37-9-21.91-12.46c-7.81-3.18-16.64-5.48-26.35-6.14v-88.69 c2.63,0.36,5.13,0.79,7.54,1.25v81.45c1.07,0.18,2.54,0.45,4.35,0.85c2.58,0.57,5.83,1.4,9.52,2.57 c1.42,0.45,2.91,0.96,4.45,1.52c0.36,0.13,0.72,0.27,1.09,0.4c2.66,1,5.45,2.17,8.33,3.53c1.82,0.86,3.68,1.81,5.55,2.83 c2.76,1.51,5.55,3.21,8.32,5.11c1.86,1.27,3.72,2.64,5.55,4.11c2.85,2.28,5.65,4.8,8.33,7.59l-0.02-119.19 c0-0.78,0.32-1.47,0.82-1.98c0.5-0.51,1.2-0.82,1.97-0.82c0.77,0,1.47,0.31,1.97,0.82c0.5,0.52,0.82,1.2,0.82,1.98l-0.02,119.19 c2.68-2.78,5.47-5.3,8.32-7.59c1.83-1.47,3.69-2.83,5.55-4.1c2.77-1.9,5.56-3.6,8.32-5.11c1.87-1.02,3.73-1.97,5.55-2.83 c2.88-1.36,5.68-2.53,8.33-3.53c0.46-0.17,0.92-0.34,1.37-0.51c1.44-0.52,2.84-0.99,4.18-1.42c3.69-1.18,6.95-2.01,9.53-2.58 c0.24-0.06,0.47-0.1,0.69-0.15c1.49-0.32,2.73-0.54,3.65-0.69v-81.45c2.43-0.46,4.96-0.89,7.63-1.26V216.41z"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "SvgLogoID_4_",
				gradientUnits: "userSpaceOnUse",
				x1: 164.5073,
				y1: 160.2475,
				x2: 152.363,
				y2: 160.2475,
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: 0,
						stopColor: "#9814A8",
						stopOpacity: 0
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .144,
						stopColor: "#9513A4",
						stopOpacity: .144
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .2991,
						stopColor: "#8C1297",
						stopOpacity: .2991
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4594,
						stopColor: "#7E0F81",
						stopOpacity: .4594
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6234,
						stopColor: "#690C63",
						stopOpacity: .6234
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7903,
						stopColor: "#4F073C",
						stopOpacity: .7903
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .9571,
						stopColor: "#2F020D",
						stopOpacity: .9571
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#260000"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#SvgLogoID_4_)",
				d: "M156.16,158.87v6.1c2.88-1.36,5.68-2.53,8.33-3.53v-5.93c-0.17,0.06-0.35,0.13-0.52,0.19 C161.48,156.61,158.87,157.65,156.16,158.87z"
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "SvgLogoID_5_",
				gradientUnits: "userSpaceOnUse",
				x1: 169.8552,
				y1: 155.5268,
				x2: 181.9294,
				y2: 155.5268,
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: 0,
						stopColor: "#9814A8",
						stopOpacity: 0
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .144,
						stopColor: "#9513A4",
						stopOpacity: .144
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .2991,
						stopColor: "#8C1297",
						stopOpacity: .2991
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4594,
						stopColor: "#7E0F81",
						stopOpacity: .4594
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6234,
						stopColor: "#690C63",
						stopOpacity: .6234
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7903,
						stopColor: "#4F073C",
						stopOpacity: .7903
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .9571,
						stopColor: "#2F020D",
						stopOpacity: .9571
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#260000"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#SvgLogoID_5_)",
				d: "M170.04,159.52c3.15-1.01,5.96-1.75,8.33-2.31v-5.68c-2.33,0.51-5.15,1.21-8.33,2.17V159.52z"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SvgLogoID_6_",
					gradientUnits: "userSpaceOnUse",
					x1: 196.3967,
					y1: 160.18,
					x2: 115.4355,
					y2: 193.5381,
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: 0,
							stopColor: "#F25B5C",
							stopOpacity: 0
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .1299,
							stopColor: "#EE595A",
							stopOpacity: .1299
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .2698,
							stopColor: "#E15354",
							stopOpacity: .2698
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .4145,
							stopColor: "#CB4A4A",
							stopOpacity: .4145
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .5625,
							stopColor: "#AD3C3D",
							stopOpacity: .5625
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .713,
							stopColor: "#862B2B",
							stopOpacity: .713
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8634,
							stopColor: "#571616",
							stopOpacity: .8634
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							stopColor: "#260000"
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "url(#SvgLogoID_6_)",
					d: "M150.61,222.12c1.87-1.02,3.73-1.97,5.55-2.83c2.88-1.36,5.68-2.53,8.33-3.53 c0.46-0.17,0.92-0.34,1.37-0.51c1.44-0.52,2.84-0.99,4.18-1.42c3.69-1.18,6.95-2.01,9.53-2.58c0.24-0.06,0.47-0.1,0.69-0.15 c1.49-0.32,2.73-0.54,3.65-0.69v-81.45v-5.72c-0.39,0.07-0.79,0.14-1.17,0.21v0.03c-1.13,0.19-2.6,0.47-4.38,0.86 c-2.32,0.51-5.14,1.21-8.32,2.18c-1.74,0.52-3.61,1.13-5.55,1.82c-0.17,0.06-0.35,0.13-0.52,0.19c-2.48,0.9-5.1,1.94-7.81,3.15 c-1.82,0.8-3.67,1.68-5.55,2.65c-2.73,1.4-5.53,2.98-8.32,4.75c-1.43,0.9-2.87,1.86-4.3,2.87v73.31 C137.99,221.77,145.18,225.66,150.61,222.12z M170.04,132.35c3.14-1,5.96-1.75,8.32-2.3v7.89c-2.32,0.52-5.14,1.22-8.32,2.18 V132.35z M170.04,145.93c3.14-1,5.96-1.74,8.32-2.3v7.9c-2.32,0.51-5.14,1.21-8.32,2.18V145.93z M170.04,159.52 c3.14-1.01,5.96-1.75,8.32-2.31v7.89c-2.32,0.51-5.14,1.21-8.32,2.18V159.52z M170.04,173.1c3.14-1,5.96-1.75,8.32-2.31v7.9 c-2.32,0.52-5.14,1.22-8.32,2.18V173.1z M170.04,186.68c3.14-1,5.96-1.74,8.32-2.3v7.89c-2.32,0.52-5.14,1.22-8.32,2.18V186.68z  M170.04,200.26c3.14-1.01,5.96-1.75,8.32-2.31v7.89c-2.32,0.51-5.14,1.21-8.32,2.18V200.26z M156.16,137.81 c2.88-1.36,5.68-2.53,8.33-3.53v7.67c-0.17,0.06-0.35,0.13-0.52,0.19c-2.48,0.9-5.1,1.94-7.81,3.15V137.81z M156.16,151.39 c2.88-1.36,5.68-2.54,8.33-3.54v7.67c-0.17,0.06-0.35,0.13-0.52,0.19c-2.48,0.9-5.1,1.94-7.81,3.15V151.39z M156.16,164.97 c2.88-1.36,5.68-2.53,8.33-3.53v7.67c-0.17,0.06-0.35,0.13-0.52,0.19c-2.48,0.9-5.1,1.94-7.81,3.15V164.97z M156.16,178.55 c2.88-1.36,5.68-2.53,8.33-3.53v7.67c-0.17,0.06-0.35,0.13-0.52,0.19c-2.48,0.9-5.1,1.94-7.81,3.15V178.55z M156.16,192.14 c2.88-1.36,5.68-2.54,8.33-3.54v7.67c-0.17,0.06-0.35,0.13-0.52,0.19c-2.48,0.9-5.1,1.94-7.81,3.15V192.14z M156.16,205.72 c2.88-1.36,5.68-2.53,8.33-3.53v7.67c-0.17,0.06-0.35,0.13-0.52,0.19c-2.48,0.9-5.1,1.94-7.81,3.15V205.72z M142.29,145.75 c2.77-1.9,5.56-3.6,8.32-5.11v7.3c-2.73,1.4-5.53,2.98-8.32,4.75V145.75z M142.29,159.33c2.77-1.9,5.56-3.6,8.32-5.11v7.3 c-2.73,1.4-5.53,2.98-8.32,4.75V159.33z M142.29,172.91c2.77-1.9,5.56-3.59,8.32-5.1v7.29c-2.73,1.4-5.53,2.98-8.32,4.75V172.91 z M142.29,186.49c2.77-1.9,5.56-3.6,8.32-5.11v7.3c-2.73,1.4-5.53,2.98-8.32,4.75V186.49z M142.29,200.07 c2.77-1.9,5.56-3.6,8.32-5.11v7.3c-2.73,1.4-5.53,2.98-8.32,4.75V200.07z M142.29,213.65c2.77-1.9,5.56-3.59,8.32-5.1v7.29 c-2.73,1.4-5.53,2.98-8.32,4.75V213.65z"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_7_",
						gradientUnits: "userSpaceOnUse",
						x1: 178.7009,
						y1: 141.938,
						x2: 166.4152,
						y2: 141.938,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_7_)",
						d: "M170.04,145.93c3.15-0.99,5.96-1.74,8.33-2.29v-5.69c-2.33,0.51-5.15,1.22-8.33,2.17V145.93z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_8_",
						gradientUnits: "userSpaceOnUse",
						x1: 150.587,
						y1: 153.6343,
						x2: 139.1843,
						y2: 153.6343,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_8_)",
						d: "M150.61,147.94c-2.74,1.41-5.54,2.97-8.33,4.75v6.64c2.77-1.9,5.57-3.6,8.33-5.12V147.94z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_9_",
						gradientUnits: "userSpaceOnUse",
						x1: 155.564,
						y1: 146.6695,
						x2: 168.2886,
						y2: 146.6695,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_9_)",
						d: "M164.49,147.86v-5.92c-0.17,0.06-0.35,0.12-0.52,0.18c-2.49,0.9-5.1,1.95-7.81,3.15v6.11 C159.04,150.03,161.84,148.86,164.49,147.86z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_10_",
						gradientUnits: "userSpaceOnUse",
						x1: 142.0184,
						y1: 167.2124,
						x2: 153.782,
						y2: 167.2124,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_10_)",
						d: "M150.61,161.51c-2.74,1.41-5.54,2.98-8.33,4.75v6.65c2.77-1.9,5.57-3.59,8.33-5.1V161.51z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_11_",
						gradientUnits: "userSpaceOnUse",
						x1: 164.5073,
						y1: 160.2475,
						x2: 152.363,
						y2: 160.2475,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_11_)",
						d: "M156.16,158.87v6.1c2.88-1.36,5.68-2.53,8.33-3.53v-5.93c-0.17,0.06-0.35,0.13-0.52,0.19 C161.48,156.61,158.87,157.65,156.16,158.87z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_12_",
						gradientUnits: "userSpaceOnUse",
						x1: 169.8552,
						y1: 155.5268,
						x2: 181.9294,
						y2: 155.5268,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_12_)",
						d: "M170.04,159.52c3.15-1.01,5.96-1.75,8.33-2.31v-5.68c-2.33,0.51-5.15,1.21-8.33,2.17V159.52z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_13_",
						gradientUnits: "userSpaceOnUse",
						x1: 155.1089,
						y1: 173.831,
						x2: 168.0447,
						y2: 173.831,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_13_)",
						d: "M156.16,172.45v6.1c2.88-1.36,5.68-2.52,8.33-3.53v-5.9c-0.17,0.05-0.35,0.12-0.52,0.18 C161.48,170.2,158.87,171.25,156.16,172.45z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_14_",
						gradientUnits: "userSpaceOnUse",
						x1: 152.0113,
						y1: 180.7958,
						x2: 138.4341,
						y2: 180.7958,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_14_)",
						d: "M150.61,175.1c-2.74,1.41-5.54,2.98-8.33,4.75v6.65c2.77-1.9,5.57-3.6,8.33-5.12V175.1z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_15_",
						gradientUnits: "userSpaceOnUse",
						x1: 179.3758,
						y1: 169.0995,
						x2: 165.9078,
						y2: 169.0995,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_15_)",
						d: "M170.04,173.1c3.15-0.99,5.96-1.75,8.33-2.3v-5.69c-2.33,0.51-5.15,1.22-8.33,2.18V173.1z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_16_",
						gradientUnits: "userSpaceOnUse",
						x1: 141.2584,
						y1: 194.3739,
						x2: 154.1657,
						y2: 194.3739,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_16_)",
						d: "M150.61,188.68c-2.74,1.41-5.54,2.98-8.33,4.75v6.64c2.77-1.89,5.57-3.59,8.33-5.1V188.68z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_17_",
						gradientUnits: "userSpaceOnUse",
						x1: 169.0253,
						y1: 182.683,
						x2: 181.6703,
						y2: 182.683,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_17_)",
						d: "M170.04,186.68c3.15-1.01,5.96-1.74,8.33-2.3v-5.69c-2.33,0.52-5.15,1.22-8.33,2.18V186.68z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_18_",
						gradientUnits: "userSpaceOnUse",
						x1: 165.4374,
						y1: 187.4146,
						x2: 152.9038,
						y2: 187.4146,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_18_)",
						d: "M156.16,186.03v6.11c2.88-1.36,5.68-2.54,8.33-3.54v-5.92c-0.17,0.06-0.35,0.13-0.52,0.19 C161.48,183.78,158.87,184.82,156.16,186.03z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_19_",
						gradientUnits: "userSpaceOnUse",
						x1: 152.0113,
						y1: 207.9573,
						x2: 138.4341,
						y2: 207.9573,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_19_)",
						d: "M150.61,202.26c-2.74,1.4-5.54,2.97-8.33,4.75v6.64c2.77-1.9,5.57-3.59,8.33-5.1V202.26z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_20_",
						gradientUnits: "userSpaceOnUse",
						x1: 155.6566,
						y1: 200.9926,
						x2: 167.382,
						y2: 200.9926,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_20_)",
						d: "M163.97,196.46c-2.49,0.91-5.1,1.95-7.81,3.16v6.1c2.88-1.36,5.68-2.53,8.33-3.53v-5.92 C164.32,196.33,164.14,196.39,163.97,196.46z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_21_",
						gradientUnits: "userSpaceOnUse",
						x1: 179.118,
						y1: 196.261,
						x2: 166.8456,
						y2: 196.261,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_21_)",
						d: "M170.04,200.26c3.15-1.01,5.96-1.75,8.33-2.3v-5.7c-2.33,0.52-5.15,1.22-8.33,2.18V200.26z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_22_",
						gradientUnits: "userSpaceOnUse",
						x1: 165.4709,
						y1: 199.799,
						x2: 169.1207,
						y2: 210.5127,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_22_)",
						d: "M165.86,201.68c-0.45,0.17-0.91,0.34-1.37,0.51v7.67c1.95-0.7,3.81-1.3,5.55-1.83v-7.76 C168.7,200.68,167.3,201.16,165.86,201.68z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_23_",
						gradientUnits: "userSpaceOnUse",
						x1: 168.7723,
						y1: 196.7983,
						x2: 165.3818,
						y2: 184.8425,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_23_)",
						d: "M164.49,188.6v7.67c1.95-0.69,3.81-1.3,5.55-1.83v-7.76c-1.34,0.42-2.74,0.9-4.17,1.42 C165.41,188.26,164.95,188.43,164.49,188.6z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_24_",
						gradientUnits: "userSpaceOnUse",
						x1: 168.8498,
						y1: 168.141,
						x2: 164.5529,
						y2: 157.7934,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_24_)",
						d: "M164.49,161.45v7.67c1.95-0.7,3.81-1.31,5.55-1.83v-7.77c-1.34,0.42-2.74,0.9-4.17,1.42 C165.41,161.1,164.95,161.28,164.49,161.45z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_25_",
						gradientUnits: "userSpaceOnUse",
						x1: 169.4465,
						y1: 142.2478,
						x2: 164.937,
						y2: 131.7255,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_25_)",
						d: "M170.04,140.12v-7.77c-1.34,0.42-2.74,0.9-4.17,1.42c-0.45,0.16-0.91,0.34-1.37,0.51v7.67 C166.44,141.26,168.3,140.65,170.04,140.12z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_26_",
						gradientUnits: "userSpaceOnUse",
						x1: 165.903,
						y1: 145.4317,
						x2: 169.2225,
						y2: 158.3539,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_26_)",
						d: "M164.49,147.86v7.66c1.95-0.68,3.81-1.29,5.55-1.82v-7.78c-1.34,0.43-2.74,0.9-4.17,1.43 C165.41,147.52,164.95,147.68,164.49,147.86z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_27_",
						gradientUnits: "userSpaceOnUse",
						x1: 165.9075,
						y1: 174.0365,
						x2: 169.3575,
						y2: 183.851,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_27_)",
						d: "M164.49,175.02v7.67c1.95-0.69,3.81-1.29,5.55-1.82v-7.78c-1.34,0.43-2.74,0.9-4.17,1.42 C165.41,174.69,164.95,174.85,164.49,175.02z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_28_",
						gradientUnits: "userSpaceOnUse",
						x1: 154.9338,
						y1: 159.8344,
						x2: 151.1795,
						y2: 151.6218,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_28_)",
						d: "M156.16,151.39c-1.83,0.87-3.68,1.81-5.55,2.82v7.3c1.88-0.96,3.73-1.84,5.55-2.64V151.39z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_29_",
						gradientUnits: "userSpaceOnUse",
						x1: 155.5298,
						y1: 186.8685,
						x2: 149.8715,
						y2: 178.2708,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_29_)",
						d: "M156.16,178.55c-1.83,0.87-3.68,1.82-5.55,2.83v7.3c1.88-0.96,3.73-1.85,5.55-2.65V178.55z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_30_",
						gradientUnits: "userSpaceOnUse",
						x1: 151.6177,
						y1: 166.1766,
						x2: 156.1003,
						y2: 175.95,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_30_)",
						d: "M156.16,164.97c-1.83,0.87-3.68,1.8-5.55,2.83v7.29c1.88-0.96,3.73-1.85,5.55-2.65V164.97z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_31_",
						gradientUnits: "userSpaceOnUse",
						x1: 152.4885,
						y1: 139.423,
						x2: 154.9132,
						y2: 148.7305,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_31_)",
						d: "M156.16,145.28v-7.47c-1.83,0.87-3.68,1.81-5.55,2.83v7.3C152.5,146.97,154.34,146.09,156.16,145.28z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_32_",
						gradientUnits: "userSpaceOnUse",
						x1: 151.0677,
						y1: 193.207,
						x2: 156.3221,
						y2: 202.2562,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_32_)",
						d: "M156.16,192.14c-1.83,0.85-3.68,1.8-5.55,2.82v7.3c1.88-0.97,3.73-1.85,5.55-2.65V192.14z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_33_",
						gradientUnits: "userSpaceOnUse",
						x1: 156.0459,
						y1: 215.2423,
						x2: 150.7915,
						y2: 206.4121,
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_33_)",
						d: "M150.61,208.55v7.29c1.88-0.95,3.73-1.85,5.55-2.65v-7.47C154.33,206.58,152.48,207.52,150.61,208.55z"
					})
				] })
			] }),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "SvgLogoID_34_",
				gradientUnits: "userSpaceOnUse",
				x1: 198.0197,
				y1: 126.8543,
				x2: 180.9023,
				y2: 126.8543,
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: 0,
						stopColor: "#F25B5C",
						stopOpacity: 0
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .1299,
						stopColor: "#EE595A",
						stopOpacity: .1299
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .2698,
						stopColor: "#E15354",
						stopOpacity: .2698
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4145,
						stopColor: "#CB4A4A",
						stopOpacity: .4145
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5625,
						stopColor: "#AD3C3D",
						stopOpacity: .5625
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .713,
						stopColor: "#862B2B",
						stopOpacity: .713
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8634,
						stopColor: "#571616",
						stopOpacity: .8634
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#260000"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#SvgLogoID_34_)",
				d: "M194.02,121.73c-2.11,0.25-4.15,0.54-6.13,0.85l-1.74,0.3c-1.29,0.22-2.24,1.34-2.24,2.66v3.45 c2.43-0.46,4.96-0.89,7.63-1.26l5.63,4.63v-11L194.02,121.73z"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SvgLogoID_35_",
					gradientUnits: "userSpaceOnUse",
					x1: 487.9781,
					y1: 160.18,
					x2: 407.0169,
					y2: 193.5381,
					gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: 0,
							stopColor: "#F25B5C",
							stopOpacity: 0
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .1299,
							stopColor: "#EE595A",
							stopOpacity: .1299
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .2698,
							stopColor: "#E15354",
							stopOpacity: .2698
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .4145,
							stopColor: "#CB4A4A",
							stopOpacity: .4145
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .5625,
							stopColor: "#AD3C3D",
							stopOpacity: .5625
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .713,
							stopColor: "#862B2B",
							stopOpacity: .713
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8634,
							stopColor: "#571616",
							stopOpacity: .8634
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							stopColor: "#260000"
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "url(#SvgLogoID_35_)",
					d: "M113.37,215.29v-73.31c-1.43-1.01-2.86-1.97-4.3-2.87c-2.79-1.77-5.59-3.35-8.32-4.75 c-1.88-0.97-3.73-1.85-5.55-2.65c-2.7-1.21-5.33-2.25-7.81-3.15c-0.17-0.06-0.35-0.13-0.52-0.19c-1.94-0.7-3.8-1.3-5.55-1.82 c-3.18-0.97-6-1.67-8.32-2.18c-1.77-0.39-3.25-0.67-4.38-0.86v-0.03c-0.39-0.07-0.78-0.14-1.17-0.21v5.72v81.45 c0.92,0.15,2.16,0.37,3.65,0.69c0.22,0.05,0.45,0.1,0.69,0.15c2.58,0.57,5.83,1.4,9.53,2.58c1.34,0.43,2.73,0.9,4.18,1.42 c0.45,0.17,0.91,0.33,1.37,0.51c2.66,1,5.45,2.16,8.33,3.53c1.82,0.86,3.68,1.81,5.55,2.83 C106.18,225.66,113.37,221.77,113.37,215.29z M81.33,140.12c-3.18-0.96-6-1.66-8.32-2.18v-7.89c2.36,0.55,5.18,1.3,8.32,2.3 V140.12z M81.33,153.71c-3.18-0.97-6-1.67-8.32-2.18v-7.9c2.36,0.55,5.18,1.3,8.32,2.3V153.71z M81.33,167.29 c-3.18-0.97-6-1.67-8.32-2.18v-7.89c2.36,0.55,5.18,1.3,8.32,2.31V167.29z M81.33,180.87c-3.18-0.96-6-1.66-8.32-2.18v-7.9 c2.36,0.55,5.18,1.31,8.32,2.31V180.87z M81.33,194.44c-3.18-0.96-6-1.66-8.32-2.18v-7.89c2.36,0.55,5.18,1.3,8.32,2.3V194.44z  M81.33,208.03c-3.18-0.97-6-1.67-8.32-2.18v-7.89c2.36,0.55,5.18,1.3,8.32,2.31V208.03z M95.2,145.28 c-2.7-1.2-5.33-2.25-7.81-3.15c-0.17-0.06-0.35-0.13-0.52-0.19v-7.67c2.66,1,5.45,2.16,8.33,3.53V145.28z M95.2,158.87 c-2.7-1.21-5.33-2.25-7.81-3.15c-0.17-0.06-0.35-0.13-0.52-0.19v-7.67c2.66,1,5.45,2.17,8.33,3.54V158.87z M95.2,172.45 c-2.7-1.2-5.33-2.25-7.81-3.15c-0.17-0.06-0.35-0.13-0.52-0.19v-7.67c2.66,1,5.45,2.16,8.33,3.53V172.45z M95.2,186.03 c-2.7-1.2-5.33-2.25-7.81-3.15c-0.17-0.06-0.35-0.13-0.52-0.19v-7.67c2.66,1,5.45,2.16,8.33,3.53V186.03z M95.2,199.61 c-2.7-1.21-5.33-2.25-7.81-3.15c-0.17-0.06-0.35-0.13-0.52-0.19v-7.67c2.66,1,5.45,2.17,8.33,3.54V199.61z M95.2,213.19 c-2.7-1.2-5.33-2.25-7.81-3.15c-0.17-0.06-0.35-0.13-0.52-0.19v-7.67c2.66,1,5.45,2.16,8.33,3.53V213.19z M109.08,152.69 c-2.79-1.77-5.59-3.35-8.32-4.75v-7.3c2.76,1.51,5.56,3.21,8.32,5.11V152.69z M109.08,166.27c-2.79-1.77-5.59-3.35-8.32-4.75 v-7.3c2.76,1.51,5.56,3.21,8.32,5.11V166.27z M109.08,179.84c-2.79-1.77-5.59-3.35-8.32-4.75v-7.29c2.76,1.51,5.56,3.2,8.32,5.1 V179.84z M109.08,193.43c-2.79-1.77-5.59-3.35-8.32-4.75v-7.3c2.76,1.51,5.56,3.21,8.32,5.11V193.43z M109.08,207.01 c-2.79-1.77-5.59-3.35-8.32-4.75v-7.3c2.76,1.51,5.56,3.21,8.32,5.11V207.01z M109.08,220.59c-2.79-1.77-5.59-3.35-8.32-4.75 v-7.29c2.76,1.51,5.56,3.2,8.32,5.1V220.59z"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_36_",
						gradientUnits: "userSpaceOnUse",
						x1: 470.2823,
						y1: 141.938,
						x2: 457.9966,
						y2: 141.938,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_36_)",
						d: "M81.33,145.93c-3.15-0.99-5.96-1.74-8.33-2.29v-5.69c2.33,0.51,5.15,1.22,8.33,2.17V145.93z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_37_",
						gradientUnits: "userSpaceOnUse",
						x1: 442.1684,
						y1: 153.6343,
						x2: 430.7657,
						y2: 153.6343,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_37_)",
						d: "M100.75,147.94c2.74,1.41,5.54,2.97,8.33,4.75v6.64c-2.77-1.9-5.57-3.6-8.33-5.12V147.94z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_38_",
						gradientUnits: "userSpaceOnUse",
						x1: 447.1454,
						y1: 146.6695,
						x2: 459.8701,
						y2: 146.6695,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_38_)",
						d: "M86.88,147.86v-5.92c0.17,0.06,0.35,0.12,0.52,0.18c2.49,0.9,5.1,1.95,7.81,3.15v6.11 C92.33,150.03,89.53,148.86,86.88,147.86z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_39_",
						gradientUnits: "userSpaceOnUse",
						x1: 433.5998,
						y1: 167.2124,
						x2: 445.3634,
						y2: 167.2124,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_39_)",
						d: "M100.75,161.51c2.74,1.41,5.54,2.98,8.33,4.75v6.65c-2.77-1.9-5.57-3.59-8.33-5.1V161.51z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_40_",
						gradientUnits: "userSpaceOnUse",
						x1: 456.0887,
						y1: 160.2475,
						x2: 443.9444,
						y2: 160.2475,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_40_)",
						d: "M95.2,158.87v6.1c-2.88-1.36-5.68-2.53-8.33-3.53v-5.93c0.17,0.06,0.35,0.13,0.52,0.19 C89.88,156.61,92.5,157.65,95.2,158.87z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_41_",
						gradientUnits: "userSpaceOnUse",
						x1: 461.4366,
						y1: 155.5268,
						x2: 473.5109,
						y2: 155.5268,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_41_)",
						d: "M81.33,159.52c-3.15-1.01-5.96-1.75-8.33-2.31v-5.68c2.33,0.51,5.15,1.21,8.33,2.17V159.52z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_42_",
						gradientUnits: "userSpaceOnUse",
						x1: 446.6904,
						y1: 173.831,
						x2: 459.6261,
						y2: 173.831,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_42_)",
						d: "M95.2,172.45v6.1c-2.88-1.36-5.68-2.52-8.33-3.53v-5.9c0.17,0.05,0.35,0.12,0.52,0.18 C89.88,170.2,92.5,171.25,95.2,172.45z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_43_",
						gradientUnits: "userSpaceOnUse",
						x1: 443.5927,
						y1: 180.7958,
						x2: 430.0155,
						y2: 180.7958,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_43_)",
						d: "M100.75,175.1c2.74,1.41,5.54,2.98,8.33,4.75v6.65c-2.77-1.9-5.57-3.6-8.33-5.12V175.1z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_44_",
						gradientUnits: "userSpaceOnUse",
						x1: 470.9572,
						y1: 169.0995,
						x2: 457.4892,
						y2: 169.0995,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_44_)",
						d: "M81.33,173.1c-3.15-0.99-5.96-1.75-8.33-2.3v-5.69c2.33,0.51,5.15,1.22,8.33,2.18V173.1z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_45_",
						gradientUnits: "userSpaceOnUse",
						x1: 432.8398,
						y1: 194.3739,
						x2: 445.7471,
						y2: 194.3739,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_45_)",
						d: "M100.75,188.68c2.74,1.41,5.54,2.98,8.33,4.75v6.64c-2.77-1.89-5.57-3.59-8.33-5.1V188.68z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_46_",
						gradientUnits: "userSpaceOnUse",
						x1: 460.6068,
						y1: 182.683,
						x2: 473.2517,
						y2: 182.683,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_46_)",
						d: "M81.33,186.68c-3.15-1.01-5.96-1.74-8.33-2.3v-5.69c2.33,0.52,5.15,1.22,8.33,2.18V186.68z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_47_",
						gradientUnits: "userSpaceOnUse",
						x1: 457.0188,
						y1: 187.4146,
						x2: 444.4852,
						y2: 187.4146,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_47_)",
						d: "M95.2,186.03v6.11c-2.88-1.36-5.68-2.54-8.33-3.54v-5.92c0.17,0.06,0.35,0.13,0.52,0.19 C89.88,183.78,92.5,184.82,95.2,186.03z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_48_",
						gradientUnits: "userSpaceOnUse",
						x1: 443.5927,
						y1: 207.9573,
						x2: 430.0155,
						y2: 207.9573,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_48_)",
						d: "M100.75,202.26c2.74,1.4,5.54,2.97,8.33,4.75v6.64c-2.77-1.9-5.57-3.59-8.33-5.1V202.26z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_49_",
						gradientUnits: "userSpaceOnUse",
						x1: 447.238,
						y1: 200.9926,
						x2: 458.9634,
						y2: 200.9926,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_49_)",
						d: "M87.4,196.46c2.49,0.91,5.1,1.95,7.81,3.16v6.1c-2.88-1.36-5.68-2.53-8.33-3.53v-5.92 C87.05,196.33,87.22,196.39,87.4,196.46z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_50_",
						gradientUnits: "userSpaceOnUse",
						x1: 470.6994,
						y1: 196.261,
						x2: 458.427,
						y2: 196.261,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_50_)",
						d: "M81.33,200.26c-3.15-1.01-5.96-1.75-8.33-2.3v-5.7c2.33,0.52,5.15,1.22,8.33,2.18V200.26z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_51_",
						gradientUnits: "userSpaceOnUse",
						x1: 457.0524,
						y1: 199.799,
						x2: 460.7021,
						y2: 210.5127,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_51_)",
						d: "M85.5,201.68c0.45,0.17,0.91,0.34,1.37,0.51v7.67c-1.95-0.7-3.81-1.3-5.55-1.83v-7.76 C82.67,200.68,84.06,201.16,85.5,201.68z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_52_",
						gradientUnits: "userSpaceOnUse",
						x1: 460.3537,
						y1: 196.7983,
						x2: 456.9632,
						y2: 184.8425,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_52_)",
						d: "M86.88,188.6v7.67c-1.95-0.69-3.81-1.3-5.55-1.83v-7.76c1.34,0.42,2.74,0.9,4.17,1.42 C85.96,188.26,86.41,188.43,86.88,188.6z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_53_",
						gradientUnits: "userSpaceOnUse",
						x1: 460.4312,
						y1: 168.141,
						x2: 456.1343,
						y2: 157.7934,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_53_)",
						d: "M86.88,161.45v7.67c-1.95-0.7-3.81-1.31-5.55-1.83v-7.77c1.34,0.42,2.74,0.9,4.17,1.42 C85.96,161.1,86.41,161.28,86.88,161.45z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_54_",
						gradientUnits: "userSpaceOnUse",
						x1: 461.028,
						y1: 142.2478,
						x2: 456.5184,
						y2: 131.7255,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_54_)",
						d: "M81.33,140.12v-7.77c1.34,0.42,2.74,0.9,4.17,1.42c0.45,0.16,0.91,0.34,1.37,0.51v7.67 C84.93,141.26,83.07,140.65,81.33,140.12z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_55_",
						gradientUnits: "userSpaceOnUse",
						x1: 457.4845,
						y1: 145.4317,
						x2: 460.8039,
						y2: 158.3539,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_55_)",
						d: "M86.88,147.86v7.66c-1.95-0.68-3.81-1.29-5.55-1.82v-7.78c1.34,0.43,2.74,0.9,4.17,1.43 C85.96,147.52,86.41,147.68,86.88,147.86z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_56_",
						gradientUnits: "userSpaceOnUse",
						x1: 457.489,
						y1: 174.0365,
						x2: 460.9389,
						y2: 183.851,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_56_)",
						d: "M86.88,175.02v7.67c-1.95-0.69-3.81-1.29-5.55-1.82v-7.78c1.34,0.43,2.74,0.9,4.17,1.42 C85.96,174.69,86.41,174.85,86.88,175.02z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_57_",
						gradientUnits: "userSpaceOnUse",
						x1: 446.5153,
						y1: 159.8344,
						x2: 442.7609,
						y2: 151.6219,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_57_)",
						d: "M95.2,151.39c1.83,0.87,3.68,1.81,5.55,2.82v7.3c-1.88-0.96-3.73-1.84-5.55-2.64V151.39z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_58_",
						gradientUnits: "userSpaceOnUse",
						x1: 447.1113,
						y1: 186.8685,
						x2: 441.4529,
						y2: 178.2708,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_58_)",
						d: "M95.2,178.55c1.83,0.87,3.68,1.82,5.55,2.83v7.3c-1.88-0.96-3.73-1.85-5.55-2.65V178.55z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_59_",
						gradientUnits: "userSpaceOnUse",
						x1: 443.1991,
						y1: 166.1766,
						x2: 447.6817,
						y2: 175.95,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_59_)",
						d: "M95.2,164.97c1.83,0.87,3.68,1.8,5.55,2.83v7.29c-1.88-0.96-3.73-1.85-5.55-2.65V164.97z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_60_",
						gradientUnits: "userSpaceOnUse",
						x1: 444.0699,
						y1: 139.423,
						x2: 446.4946,
						y2: 148.7305,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_60_)",
						d: "M95.2,145.28v-7.47c1.83,0.87,3.68,1.81,5.55,2.83v7.3C98.87,146.97,97.02,146.09,95.2,145.28z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_61_",
						gradientUnits: "userSpaceOnUse",
						x1: 442.6492,
						y1: 193.207,
						x2: 447.9035,
						y2: 202.2562,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_61_)",
						d: "M95.2,192.14c1.83,0.85,3.68,1.8,5.55,2.82v7.3c-1.88-0.97-3.73-1.85-5.55-2.65V192.14z"
					}),
					/* @__PURE__ */ _jsxs("linearGradient", {
						id: "SvgLogoID_62_",
						gradientUnits: "userSpaceOnUse",
						x1: 447.6273,
						y1: 215.2423,
						x2: 442.373,
						y2: 206.4121,
						gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
						children: [
							/* @__PURE__ */ _jsx("stop", {
								offset: 0,
								stopColor: "#9814A8",
								stopOpacity: 0
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .144,
								stopColor: "#9513A4",
								stopOpacity: .144
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .2991,
								stopColor: "#8C1297",
								stopOpacity: .2991
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .4594,
								stopColor: "#7E0F81",
								stopOpacity: .4594
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .6234,
								stopColor: "#690C63",
								stopOpacity: .6234
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .7903,
								stopColor: "#4F073C",
								stopOpacity: .7903
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: .9571,
								stopColor: "#2F020D",
								stopOpacity: .9571
							}),
							/* @__PURE__ */ _jsx("stop", {
								offset: 1,
								stopColor: "#260000"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "url(#SvgLogoID_62_)",
						d: "M100.75,208.55v7.29c-1.88-0.95-3.73-1.85-5.55-2.65v-7.47C97.03,206.58,98.88,207.52,100.75,208.55z"
					})
				] })
			] }),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "SvgLogoID_63_",
				gradientUnits: "userSpaceOnUse",
				x1: 489.6012,
				y1: 126.8543,
				x2: 472.4837,
				y2: 126.8543,
				gradientTransform: "matrix(-1 0 0 1 542.9467 0)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: 0,
						stopColor: "#F25B5C",
						stopOpacity: 0
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .1299,
						stopColor: "#EE595A",
						stopOpacity: .1299
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .2698,
						stopColor: "#E15354",
						stopOpacity: .2698
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4145,
						stopColor: "#CB4A4A",
						stopOpacity: .4145
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5625,
						stopColor: "#AD3C3D",
						stopOpacity: .5625
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .713,
						stopColor: "#862B2B",
						stopOpacity: .713
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8634,
						stopColor: "#571616",
						stopOpacity: .8634
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#260000"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#SvgLogoID_63_)",
				d: "M57.35,121.73c2.11,0.25,4.15,0.54,6.13,0.85l1.74,0.3c1.29,0.22,2.24,1.34,2.24,2.66v3.45 c-2.43-0.46-4.96-0.89-7.63-1.26l-5.63,4.63v-11L57.35,121.73z"
			})
		] }),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "SvgLogoID_64_",
			gradientUnits: "userSpaceOnUse",
			x1: 161.5443,
			y1: 117.9957,
			x2: 130.9613,
			y2: 117.9957,
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#F25B5C",
					stopOpacity: 0
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .1299,
					stopColor: "#EE595A",
					stopOpacity: .1299
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .2698,
					stopColor: "#E15354",
					stopOpacity: .2698
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .4145,
					stopColor: "#CB4A4A",
					stopOpacity: .4145
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5625,
					stopColor: "#AD3C3D",
					stopOpacity: .5625
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .713,
					stopColor: "#862B2B",
					stopOpacity: .713
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .8634,
					stopColor: "#571616",
					stopOpacity: .8634
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#260000"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#SvgLogoID_64_)",
			d: "M137.99,113.33v15.28c0-0.24,0.01-0.48,0.03-0.72c0.01-0.17,0.02-0.32,0.04-0.48 c0.03-0.39,0.1-0.78,0.18-1.15c0.17-0.86,0.44-1.66,0.79-2.43c0.03-0.09,0.07-0.17,0.11-0.26l0.02-0.02 c1.25-2.55,3.39-4.59,6.02-5.69c0.88-0.37,1.81-0.64,2.77-0.78c0.58-0.09,1.17-0.13,1.78-0.13c0.13,0,0.28-0.01,0.41-0.02 c0.16-0.02,0.31-0.04,0.45-0.06c0.44-0.07,0.88-0.21,1.28-0.4c0.1-0.05,0.21-0.1,0.32-0.16c0.15-0.09,0.31-0.17,0.44-0.29 c0.09-0.06,0.17-0.11,0.25-0.18c0.08-0.06,0.13-0.11,0.21-0.17c0.22-0.19,0.42-0.41,0.6-0.64l0.02-0.02 c0.26-0.35,0.48-0.74,0.64-1.15c0.04-0.1,0.08-0.21,0.12-0.33c0.02-0.09,0.06-0.18,0.06-0.29l0.03-0.13 c0.03-0.1,0.05-0.19,0.06-0.29c0.02-0.1,0.03-0.22,0.04-0.34c0.04-0.6-0.04-1.19-0.2-1.74c-0.1-0.29-0.22-0.57-0.37-0.85 c-0.22-0.4-0.49-0.78-0.82-1.09c-0.32-0.33-0.69-0.61-1.11-0.83c-0.67-0.36-1.44-0.58-2.27-0.58h-5.96 C140.66,107.38,137.99,110.04,137.99,113.33z"
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "SvgLogoID_65_",
			gradientUnits: "userSpaceOnUse",
			x1: 539.3607,
			y1: 118.0053,
			x2: 508.7776,
			y2: 118.0053,
			gradientTransform: "matrix(-1 0 0 1 629.0959 0)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#F25B5C",
					stopOpacity: 0
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .1299,
					stopColor: "#EE595A",
					stopOpacity: .1299
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .2698,
					stopColor: "#E15354",
					stopOpacity: .2698
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .4145,
					stopColor: "#CB4A4A",
					stopOpacity: .4145
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5625,
					stopColor: "#AD3C3D",
					stopOpacity: .5625
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .713,
					stopColor: "#862B2B",
					stopOpacity: .713
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .8634,
					stopColor: "#571616",
					stopOpacity: .8634
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#260000"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#SvgLogoID_65_)",
			d: "M113.29,113.34v15.28c0-0.24-0.01-0.48-0.03-0.72c-0.01-0.17-0.02-0.32-0.04-0.48 c-0.03-0.39-0.1-0.78-0.18-1.15c-0.17-0.86-0.44-1.66-0.79-2.43c-0.03-0.09-0.07-0.17-0.11-0.26l-0.02-0.02 c-1.25-2.55-3.39-4.59-6.02-5.69c-0.88-0.37-1.81-0.64-2.77-0.78c-0.58-0.09-1.17-0.13-1.78-0.13c-0.13,0-0.28-0.01-0.41-0.02 c-0.16-0.02-0.31-0.04-0.45-0.06c-0.44-0.07-0.88-0.21-1.28-0.4c-0.1-0.05-0.21-0.1-0.32-0.16c-0.15-0.09-0.31-0.17-0.44-0.29 c-0.09-0.06-0.17-0.11-0.25-0.18c-0.08-0.06-0.13-0.11-0.21-0.17c-0.22-0.19-0.42-0.41-0.6-0.64l-0.02-0.02 c-0.26-0.35-0.48-0.74-0.64-1.15c-0.04-0.1-0.08-0.21-0.12-0.33c-0.02-0.09-0.06-0.18-0.06-0.29l-0.03-0.13 c-0.03-0.1-0.05-0.19-0.06-0.29c-0.02-0.1-0.03-0.22-0.04-0.34c-0.04-0.6,0.04-1.19,0.2-1.74c0.1-0.29,0.22-0.57,0.37-0.85 c0.22-0.4,0.49-0.78,0.82-1.09c0.32-0.33,0.69-0.61,1.11-0.83c0.67-0.36,1.44-0.58,2.27-0.58h5.96 C110.62,107.39,113.29,110.05,113.29,113.34z"
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "SvgLogoID_66_",
			gradientUnits: "userSpaceOnUse",
			x1: 125.5885,
			y1: 137.3805,
			x2: 125.5885,
			y2: 105.2732,
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#F25B5C",
					stopOpacity: 0
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .1299,
					stopColor: "#EE595A",
					stopOpacity: .1299
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .2698,
					stopColor: "#E15354",
					stopOpacity: .2698
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .4145,
					stopColor: "#CB4A4A",
					stopOpacity: .4145
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5625,
					stopColor: "#AD3C3D",
					stopOpacity: .5625
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .713,
					stopColor: "#862B2B",
					stopOpacity: .713
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .8634,
					stopColor: "#571616",
					stopOpacity: .8634
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#260000"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#SvgLogoID_66_)",
			d: "M125.64,116.94c0.77,0,1.47,0.31,1.97,0.82c0.33,0.35,0.58,0.77,0.71,1.25v-2.87c0-1.51-1.22-2.73-2.73-2.73 s-2.73,1.22-2.73,2.73v3.59c0-0.77,0.32-1.45,0.81-1.96C124.17,117.25,124.87,116.94,125.64,116.94z"
		})
	] })] })
});
export default SvgLogoWordmark;
